import React, { FC, ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

interface Props {
  title: ReactNode;
  className?: string;
}

const SubTitle: FC<Props> = ({ title, className }) => {
  return (
    <p
      className={twMerge(
        `text-white md:text-lg text-sm  text-center`,
        className,
      )}
    >
      {title}
    </p>
  );
};

export default SubTitle;
